export default __webpack_public_path__ + "static/media/ClientIcon.a6c00813.svg";